import script from "./PopupMenuIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./PopupMenuIcon.vue?vue&type=script&setup=true&lang=js"

import "./PopupMenuIcon.vue?vue&type=style&index=0&id=1d26f8fe&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d26f8fe"]])

export default __exports__